/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PostBookingPlanSuccessResponseData,
    PostBookingPlanSuccessResponseDataFromJSON,
    PostBookingPlanSuccessResponseDataFromJSONTyped,
    PostBookingPlanSuccessResponseDataToJSON,
} from './PostBookingPlanSuccessResponseData';

/**
 * 
 * @export
 * @interface PostUpdatePlanSuccessResponse
 */
export interface PostUpdatePlanSuccessResponse {
    /**
     * status code (HTTPと同じ)
     * @type {number}
     * @memberof PostUpdatePlanSuccessResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof PostUpdatePlanSuccessResponse
     */
    message: string;
    /**
     * 
     * @type {PostBookingPlanSuccessResponseData}
     * @memberof PostUpdatePlanSuccessResponse
     */
    data: PostBookingPlanSuccessResponseData;
}

export function PostUpdatePlanSuccessResponseFromJSON(json: any): PostUpdatePlanSuccessResponse {
    return PostUpdatePlanSuccessResponseFromJSONTyped(json, false);
}

export function PostUpdatePlanSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostUpdatePlanSuccessResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PostBookingPlanSuccessResponseDataFromJSON(json['data']),
    };
}

export function PostUpdatePlanSuccessResponseToJSON(value?: PostUpdatePlanSuccessResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PostBookingPlanSuccessResponseDataToJSON(value.data),
    };
}

